<template>
    <div>
        <headerNavbar title="修改人员信息" />
        <profileEdit v-model="profile" action='edit' />
    </div>
</template>

<style scoped>

</style>

<script>
    import profileEdit from '@/components/profileEdit';
    import headerNavbar from '@/views/components/headerNavbar';
    import * as api_user from "@/api/user";
    export default {
        components: {
            profileEdit,
            headerNavbar
        },
        data() {
            return {
                profile: null,
            }
        },
        mounted() {
            api_user.getUserProfiles().then(res => {
                console.log(res);
                if (res.data) {
                    this.profile = res.data.find(it => it.id == this.$route.query.pid);
                    console.log(this.profile);
                }
            });

        },
    }
</script>